import { queryOptions } from '@tanstack/react-query';
import { listUsers } from '~/pages/Users/api/users.api';
import { UsersModel } from '~/pages/Users/models/UsersModel';

export const listUsersQuery = () =>
  queryOptions({
    queryKey: ['users'],
    queryFn: async () => {
      const response = await listUsers();

      return new UsersModel(response);
    },
  });
